<template>
  <div>
    <section>
      <div class="container">
        <!-- title and ADD column -->
        <div class="columns is-mobile">
          <div class="column">
            <p class="title has-text-left">Experimental Plans</p>
          </div>
          <div class="column">
            <p class="has-text-right">
              <help-button-component :url="`${domain}media/help/plans.pdf`" :as_icon="true"></help-button-component>
            </p>
          </div>
        </div>

        <!-- First Column -->
        <div class="columns is-mobile is-centered">
          <div class="column">
            <section>
              <b-collapse class="panel" :open.sync="isOpenActive">
                <div slot="trigger" class="panel-heading">
                  <p class="has-text-left">Active Experimental Plans</p>
                </div>

                <div class="panel-block">
                  <div class="container">
                    <!-- search start -->
                    <b-field>
                      <b-input v-model="keyword" type="search" placeholder="Search names..." expanded>
                        <button class="button is-primary">Search names...</button>
                      </b-input>
                    </b-field>
                    <!-- search end -->


                    <!-- Active Data -->
                    <section>
                      <!-- TableComponent -->
                      <table-component :tableData="activeItems" :keyword="keyword" @view="viewExperimentalPlan"
                                       :customColumns="customColumns">
                                                <span class="" slot="actionButtons" slot-scope="props">
                                                    <span>
                                                        <view-icon-button-component :row_data="props.tableRow.row"
                                                                                    @view="viewExperimentalPlan"></view-icon-button-component>
                                                        <span style="margin-right:10px"></span>
                                                    </span>

                                                    <span v-if="props.tableRow.row.status!='LOCKED'">
                                                        <edit-icon-button-component :row_data="props.tableRow.row"
                                                                                    @edit="editExperimentalPlan"></edit-icon-button-component>
                                                        <span style="margin-right:10px"></span>
                                                    </span>

                                                    <span
                                                        v-if="props.tableRow.row.status!='LOCKED' && props.tableRow.row.status!='COMPLETED'">
                                                        <complete-icon-button-component
                                                            @complete="completeExperimentalPlan"
                                                            :row_data="props.tableRow.row"></complete-icon-button-component>
                                                        <span style="margin-right:10px"></span>
                                                    </span> 
                                                    
                                                    <span>
                                                        <duplicate-icon-button-component :row_data="props.tableRow.row"
                                                                                         @duplicate="isDuplicateModalActive = true; currentPlanName = props.tableRow.row.name; duplicatePlanButtonClick(props.tableRow.row)"></duplicate-icon-button-component>
                                                        <span style="margin-right:10px"></span>
                                                    </span>

                                                    <span v-if="props.tableRow.row.status!='LOCKED'">
                                                        <archive-icon-button-component
                                                            @archive="archiveExperimentalPlan"
                                                            :row_data="props.tableRow.row"></archive-icon-button-component>
                                                    </span>            
                                                </span>
                      </table-component>
                      <!-- /TableComponent -->
                    </section>
                    <!-- Active Data end -->
                  </div>
                </div>
              </b-collapse>
            </section>
          </div>
        </div>

        <!-- Second Column -->
        <div class="columns is-mobile is-centered">
          <div class="column">
            <section>
              <b-collapse class="panel" :open.sync="isOpenArchived">
                <div slot="trigger" class="panel-heading">
                  <p class="has-text-left">Archived Experimental Plans</p>
                </div>

                <div class="panel-block">
                  <div class="container">
                    <!-- search start -->
                    <b-field>
                      <b-input v-model="archiveKeyword" type="search" placeholder="Search names..." expanded>
                        <button class="button is-primary">Search names...</button>
                      </b-input>
                    </b-field>
                    <!-- search end -->

                    <!-- Archive Data -->
                    <section>
                      <!-- TableComponent -->
                      <table-component :tableData="archivedItems" :keyword="archiveKeyword"
                                       :customColumns="customColumns">
                                                <span class="" slot="actionButtons" slot-scope="props">            
                                                    <duplicate-icon-button-component :row_data="props.tableRow.row"
                                                                                     @duplicate="isDuplicateModalActive = true; currentPlanName = props.tableRow.row.name; duplicatePlanButtonClick(props.tableRow.row)"></duplicate-icon-button-component>
                                                </span>
                      </table-component>
                      <!-- /TableComponent -->
                    </section>
                    <!-- Archive Data end -->
                  </div>
                </div>
              </b-collapse>
            </section>
          </div>
        </div>
      </div>
    </section>


    <!-- Modal Start -->
    <b-modal :active.sync="isDuplicateModalActive">
      <section class="modal-card-body">
        <p class="subtitle is-uppercase box">Duplicate experimental plan</p>
        <div class="columns has-text-left">
          <div class="column is-one-third">
            <p class="has-text-weight-bold">Existing plan name:</p>
          </div>
          <div class="column">
            {{ currentPlanName }}
          </div>
        </div>
        <b-field class="has-text-left" label="Plan name:">
          <b-input
              type="text"
              v-model="duplicatePlanName"
              placeholder="Enter the new name for the duplicate plan..."
              required>
          </b-input>
        </b-field>
      </section>

      <footer class="modal-card-foot has-text-right">
        <button v-on:click="duplicatePlan" class="button is-primary is-fullwidth">Duplicate</button>
        <button v-on:click="isDuplicateModalActive = false" class="button is-fullwidth">Cancel</button>
      </footer>
    </b-modal>
    <!-- Modal End -->


    <router-link to="/new-experimental-plan">
      <new-float-button-component :tooltipMessage="'Create a new Plan'"></new-float-button-component>
    </router-link>

  </div>
</template>

<script>
import TableComponent from '../features/tables/TableComponent'
import ViewIconButtonComponent from '../features/buttons/ViewIconButtonComponent'
import EditIconButtonComponent from '../features/buttons/EditIconButtonComponent'
import DuplicateIconButtonComponent from '../features/buttons/DuplicateIconButtonComponent'
import ArchiveIconButtonComponent from '../features/buttons/ArchiveIconButtonComponent'
import CompleteIconButtonComponent from '../features/buttons/CompleteIconButtonComponent'
import NewFloatButtonComponent from '../features/buttons/NewFloatButtonComponent'
import HelpButtonComponent from '../features/buttons/HelpButtonComponent'
import {mapGetters} from 'vuex'

export default {
  name: "ExperimentalPlansComponent",
  components: {
    TableComponent,
    ViewIconButtonComponent,
    EditIconButtonComponent,
    DuplicateIconButtonComponent,
    ArchiveIconButtonComponent,
    NewFloatButtonComponent,
    CompleteIconButtonComponent,
    HelpButtonComponent
  },
  props: ["activeExperimentalPlans", "archivedExperimentalPlans"],
  data() {

    return {
      // Duplicate Modal
      isDuplicateModalActive: false,
      currentPlanName: '',
      duplicatePlanName: '',
      //
      keyword: '',
      archiveKeyword: '',
      isEmpty: false,
      isLoading: false,
      isOpenActive: true,
      isOpenArchived: false,
      customColumns: [
        {value: 'method', lable: 'Method'},
        {value: 'template', lable: 'Template'}
      ]
    }
  },
  computed: {
    ...mapGetters([
      'domain'
    ]),
    activeItems() {
      return this.keyword
          ? this.activeExperimentalPlans.filter(item => item.name.toLowerCase().includes(this.keyword.toLowerCase()) || item.status.toLowerCase().includes(this.keyword.toLowerCase()) || item.template.name.toLowerCase().includes(this.keyword.toLowerCase()) || item.method.name.toLowerCase().includes(this.keyword.toLowerCase()))
          : this.activeExperimentalPlans
    },
    archivedItems() {
      return this.archiveKeyword
          ? this.archivedExperimentalPlans.filter(item => item.name.toLowerCase().includes(this.archiveKeyword.toLowerCase()) || item.status.toLowerCase().includes(this.archiveKeyword.toLowerCase()) || item.template.name.toLowerCase().includes(this.archiveKeyword.toLowerCase()) || item.method.name.toLowerCase().includes(this.archiveKeyword.toLowerCase()))
          : this.archivedExperimentalPlans
    }
  },
  methods: {
    cache() {
      console.log('Cache Cleared');
    },
    alert() {
      alert('Clicked on alert icon');
    },
    viewExperimentalPlan: function (currentExperimentalPlan) {
      console.log("view btn clicked for: ", currentExperimentalPlan)
      this.$emit("viewExperimentalPlan", currentExperimentalPlan);
    },
    editExperimentalPlan: function (currentExperimentalPlan) {
      console.log("edit btn clicked for: ", currentExperimentalPlan.name)
      this.$emit("editExperimentalPlan", currentExperimentalPlan);
    },
    experimentalDatasets: function (currentExperimentalPlan) {
      console.log("experimentalDataset btn clicked for: ", currentExperimentalPlan.name)
      this.$emit("experimentalDatasets", currentExperimentalPlan);
    },
    duplicatePlanButtonClick: function (currentPlan) {
      this.duplicateCurrentPlan = currentPlan
      // console.log("name old: ", this.duplicateCurrentPlan)
    },
    duplicatePlan: function () {
      this.duplicateCurrentPlan.name = this.duplicatePlanName
      console.log("name change: ", this.duplicateCurrentPlan)
      // delete this.duplicateCurrentPlan.datasets

      this.duplicateCurrentPlan.template = this.duplicateCurrentPlan.template.id
      this.duplicateCurrentPlan.method = this.duplicateCurrentPlan.method.id

      this.$emit("duplicatePlan", this.duplicateCurrentPlan);
      this.isDuplicateModalActive = false
    },
    archiveExperimentalPlan: function (currentExperimentalPlan) {
      this.$dialog.confirm({
        title: 'Archive Experimental Plan',
        message: 'Are you sure you want to <b>archive</b> this Experimental Plan? This action cannot be undone.',
        confirmText: 'Archive Experimental Plan',
        type: 'is-warning',
        hasIcon: true,
        onConfirm: () => this.$emit("archiveExperimentalPlan", currentExperimentalPlan)
      })
    },
    completeExperimentalPlan: function (currentExperimentalPlan) {
      this.$emit("completeExperimentalPlan", currentExperimentalPlan)
    },
  }
}
</script>

